import { newRequest } from "std/api/newRequest";
import type { ApiBaseParams } from "std/api/types";
import type { ProdutorStoreFilter } from "../store";
import type { ApiProdutor } from "../types/ApiProdutor";

export type ApiProdutorGetSearchParams = ApiBaseParams &
	Omit<Partial<ProdutorStoreFilter>, "for_data_cadastro" | "for_rota"> &
	Partial<{
		for_data_cadastro_inicio: string;
		for_data_cadastro_fim: string;
		for_rota_idpk: number;
	}>;

export function apiProdutorGetSearch({ idpk, params }: { idpk?: number; params?: ApiProdutorGetSearchParams }): Promise<ApiProdutor[]> {
	return newRequest({
		url: "Produtor/Search",
		type: "get",
		idpk,
		params,
	});
}
